module.exports = __webpack_public_path__ + "static/media/OH3@2x.2b672d28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/OH/OH3@2x.png
// module id = 705
// module chunks = 0